import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/like.svg";
var LikeSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LikeSolid_default as default
};
